/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isUndefined } from 'lodash';

class ModalButtons extends Component {
  state = {
    loading: false,
    submitting: false,
  };

  handleCloseClick = (action) => () => {
    const { onClose } = this.props;
    if (typeof action === 'function') {
      action();
    }
    onClose();
  };

  handleButtonClick = (action, isSubmit) => async () => {
    const { showError, t } = this.props;
    try {
      if (typeof action !== 'function') {
        return;
      }
      this.setState({
        ...(isSubmit && { submitting: true }),
        ...(!isSubmit && { loading: true }),
      });
      await action();
    } catch (err) {
      showError(t('titleErrorPage'));
    } finally {
      this.setState({
        ...(isSubmit && { submitting: false }),
        ...(!isSubmit && { loading: false }),
      });
    }
  };

  isDisabled = (disabled) => {
    if (typeof disabled === 'function') {
      return disabled();
    }
    return disabled;
  };
  render() {
    const { t, buttons, reverse, showInFooter, boxCenter } = this.props;
    const { loading, submitting } = this.state;
    const classes = classNames('buttons-container', boxCenter, { 'buttons-container-footer': showInFooter });
    return (
      <div className={classes}>
        {buttons.map(({ name, text, disabled = false, action, isLoading, type, className }) => {
          const classClose = classNames('btn', className, { 'btn-ghost': !reverse, 'btn-primary': reverse });
          const classDark = classNames('btn', className, { 'btn-ghost': reverse, 'btn-primary': !reverse });
          const classBlue = classNames('btn', className, { 'btn-ghost': reverse, 'btn-primary': !reverse });
          if (name === 'confirmClose') {
            return (
              <button key={name} className={'btn btn-dark'} type="button" name={name} onClick={this.handleCloseClick(action)} disabled={loading || submitting}>
                {t(text)}
              </button>
            );
          }
          if (name === 'confirmation') {
            return (
              <button key={name} className={'btn btn-ghost dark'} type="button" name={name} onClick={this.handleCloseClick(action)} disabled={loading || submitting}>
                {t(text)}
              </button>
            );
          }
          if (name === 'close') {
            return (
              <button key={name} className={classClose} type="button" name={name} onClick={this.handleCloseClick(action)} disabled={loading || submitting}>
                {t(text)}
              </button>
            );
          }
          if (type === 'submit') {
            return (
              <button key={name} className={classDark} type="submit" name={name} onClick={this.handleButtonClick(action, true)} disabled={this.isDisabled(disabled)}>
                {submitting && <FontAwesomeIcon icon="spinner" size="lg" spin className="mx-2" />}
                {!submitting && t(text)}
              </button>
            );
          }
          return (
            <button
              key={name}
              className={classBlue}
              type="button"
              name={name}
              onClick={this.handleButtonClick(action, false)}
              disabled={this.isDisabled(disabled) || loading || submitting}
            >
              {(isUndefined(isLoading) && loading) || isLoading ? loading && <FontAwesomeIcon icon="spinner" size="lg" spin className="mx-2" /> : null}
              {t(text)}
            </button>
          );
        })}
      </div>
    );
  }
}

ModalButtons.defaultProps = {
  reverse: false,
  showInFooter: false,
};

export default withNamespaces()(ModalButtons);
